<template>
    <div id="component-promoter-agent">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">
            <modal-sinisters-list></modal-sinisters-list>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="row">
                <div class="accordion accordion-flush" id="accordionExample">
                    <div v-for="(client,index) in clients" :key="client.id" class="accordion-item">
                        <h2 class="accordion-header" :id="'flush-headingOne'+index">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    :data-bs-target="'#flush-collapseOne'+index" aria-expanded="false"
                                    aria-controls="flush-collapseOne">
                                <span v-if="client.tipo_per===1" class="fisica">{{ client.sku }} - {{ client.nombre }} {{
                                        client.paterno
                                    }} {{ client.materno }}</span>
                                <span v-else class="moral">{{ client.sku }} - {{ client.nmComPerMoral }}</span>

                            </button>
                        </h2>
                        <div :id="'flush-collapseOne'+index" class="accordion-collapse collapse"
                             :aria-labelledby="'flush-headingOne'+index" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                                <span class="badge rounded-pill text-bg-blue mb-2">>Suma total de los siniestros: ${{ client.total }}</span>
                                <hr>
                                <h5 class="text-center m-2">PROVEEDORES</h5>
                                <ul v-for="(item,index) in client.sinisters" :key="item.table">
                                    <li>
                                        <hr v-if="index!==0">
                                        <strong class="badge rounded-pill text-bg-orange mb-2">{{ item.table }}</strong>
                                        <ul class="row">
                                            <li class="col text-center" v-for="monthItem in item.month" :key="monthItem.month">
                                                <a href="javascript:void(0)" class="badge rounded-pill text-bg-blue mb-2">
                                                    <strong>{{ monthItem.month }}</strong>
                                                </a>
                                                <br>${{ monthItem.total }}
                                            </li>
                                        </ul>
                                    </li>

                                </ul>
                                <h5 class="text-center m-2 mt-5">ESPECIALISTAS</h5>
                                <ul v-for="(item,index) in client.sinisters_specialist" :key="item.table">
                                    <li>
                                        <hr v-if="index!==0">
                                        <strong class="badge rounded-pill text-bg-orange mb-2">{{ item.specialist }}</strong>
                                        <ul class="row">
                                            <li class="col text-center" v-for="monthItem in item.month" :key="monthItem.month">
                                                <a href="javascript:void(0)" class="badge rounded-pill text-bg-blue mb-2">
                                                    <strong>{{ monthItem.month }}</strong>
                                                </a>
                                                <br>${{ monthItem.total }}
                                            </li>
                                        </ul>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {reportService} from "../../Services/Reports";
import {myMixins} from "../mixins/myMixins";

export default {
    name: "report-clients",
    mixins: [myMixins],
    data() {
        return {
            clients: [],
        }
    },
    methods: {
        async index() {
            this.clients = await reportService.getMany({});

        },

    },
    mounted() {
        reportService.setRoute('api/report-clients');
        this.index();
    }
}
</script>

<style scoped>
#agentList {
    list-style: none;
    padding: 0;
}

#agentList li {
    padding: 10px;
    border-bottom: 1px solid #ccc;
}

.accordion-button {
    text-transform: uppercase;
}
</style>
